import axios from 'axios';
import { useEffect, useState } from 'react';

const useAdmin = (user) => {
    const [admin, setAdmin] = useState(false);
    const [adminLoading, setAdminLoading] = useState(true);

    useEffect(() => {
        const email = user?.email;

        if (email) {
            (async () => {
                const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/bms/admin/${email}`
                const { data } = await axios.get(url)
                setAdmin(data.admin);
                setAdminLoading(false);
            })();
        }

    }, [user]);

    return [admin, adminLoading];
};

export default useAdmin;